import { Injectable } from '@angular/core';
import {PriceMediaAdapter} from "./price-media.adapter";
import {Observable} from "rxjs";
import {PriceMediaRequestConfig, PriceMediaStatusRequest} from "./price-media.model";

@Injectable({
  providedIn: 'root'
})
export class PriceMediaService {

  constructor(private priceMediaAdapter: PriceMediaAdapter) { }

  loadPriceMedia(priceMedia: any) : Observable<any> {
    return this.priceMediaAdapter.loadPriceMedia(priceMedia);
  }

  getPriceMedias(requestConfig: PriceMediaRequestConfig): Observable<PriceMediaStatusRequest> {
    return this.priceMediaAdapter.getPriceMedias(requestConfig);
  }

}
